
      import { init } from "./src/main.js";
      init();
    